// Public (anonymous) status page
import StatusHome from './pageComponents/public/StatusHome.svelte';
import ServiceDetailPage from './pageComponents/public/ServiceDetailPage.svelte';
import IncidentsHistory from './pageComponents/public/IncidentsHistory.svelte';

// Authenticated admin area
import Dashboard from './pageComponents/Dashboard.svelte';
import Settings from './pageComponents/Settings.svelte';
import Users from './pageComponents/Users.svelte';
import AdminServices from './pageComponents/admin/AdminServices.svelte';
import AdminProbes from './pageComponents/admin/AdminProbes.svelte';
import AdminMetrics from './pageComponents/admin/AdminMetrics.svelte';
import AdminIncidents from './pageComponents/admin/AdminIncidents.svelte';
import AdminAlertChannels from './pageComponents/admin/AdminAlertChannels.svelte';
import AdminScaling from './pageComponents/admin/AdminScaling.svelte';

import Handle404 from './pageComponents/404.svelte';

export default {
	// Public
	'/': StatusHome,
	'/Incidents': IncidentsHistory,
	'/Service/:slug': ServiceDetailPage,

	// Admin
	'/Admin': Dashboard,
	'/Admin/Services': AdminServices,
	'/Admin/Groups': AdminServices, // merged into Services (kept so old links don't 404)
	'/Admin/Probes': AdminProbes,
	'/Admin/Metrics': AdminMetrics,
	'/Admin/Incidents': AdminIncidents,
	'/Admin/Alerts': AdminAlertChannels,
	'/Admin/Scaling': AdminScaling,
	'/Admin/Users': Users,
	'/Admin/Settings': Settings,
	'/Admin/Settings/*': Settings,

	'*': Handle404
};
